import className from 'classnames/bind';
import { graphql, useStaticQuery } from 'gatsby';
import GatsbyImage from 'gatsby-image';
import React from 'react';

import { BREAKPOINT_MD } from 'constants/breakpoints';
import useWindowWidth from 'hooks/use-window-width';

import styles from './sneakers-background.module.scss';

const cx = className.bind(styles);

const SneakersBackground = ({ isAnimated = false }) => {
  const {
    yeezy,
    // eslint-disable-next-line no-use-before-define
  } = useStaticQuery(IMAGE_QUERY);

  const windowWidth = useWindowWidth();

  const sneakersScreen = () => {
    return (
      <>
        <div className={cx('bg-image', 'bg-image-1')}>
          <GatsbyImage fluid={yeezy.childImageSharp.fluid} fadeIn={false} />
        </div>
        <div className={cx('bg-image', 'bg-image-2')}>
          <GatsbyImage fluid={yeezy.childImageSharp.fluid} fadeIn={false} />
        </div>
        <div className={cx('bg-image', 'bg-image-3')}>
          <GatsbyImage fluid={yeezy.childImageSharp.fluid} fadeIn={false} />
        </div>
        <div className={cx('bg-image', 'bg-image-4')}>
          <GatsbyImage fluid={yeezy.childImageSharp.fluid} fadeIn={false} />
        </div>
      </>
    );
  };

  return (
    <>
      <div className={cx('bg', isAnimated && 'bg-1')}>{sneakersScreen()}</div>
      <div className={cx('bg', isAnimated && 'bg-2')} />
      <div className={cx('bg', isAnimated && 'bg-3')}>{sneakersScreen()}</div>
    </>
  );
};

export default SneakersBackground;

const IMAGE_QUERY = graphql`
  query {
    yeezy: file(relativePath: { eq: "pages/home/dropping/yeezy-flipped.png" }) {
      id
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
  }
`;
